module.exports = __webpack_public_path__ + "logoCnrs.jpg?ed4b6591129aa63ec82225a22da0f4ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logoCnrs.jpg
// module id = 675
// module chunks = 0